<template>
  <div class="phone-map-page">
    <transition enter-active-class="animated fadeInRight" leave-active-class="animated slideOutLeft">
      <city-address v-if="addressShowBool" :current-page="currentPage" @currentParams="currentParamsVal"></city-address>
    </transition>
    <div class="map-top" ref="mapTop">
      <div class="top">
        <div class="clearFloat">
          <div class="address-name" @click="goAddressPage">{{addressCity.name}} <i class="icon-img icon-down-white"></i></div>
          <i class="icon-img icon-back" @click="goBack"></i>
        </div>
      </div>
      <div class="map-info">
        <div class="map-search-industry">
          <div class="map-search"  @mouseenter="searchEnter">
            <input type="text" placeholder="搜索关键词"
                   v-model="searchKeyVal"
                   @input="searchInput"
                   @compositionstart="compositionstart"
                   @compositionend="compositionend"
            >
            <span @click="searchInput">搜索</span>
          </div>
          <div class="map-industry" :class="[navBool?'active':'']" @click="industryFun">{{navName}}<i class="icon-img icon-down"></i></div>
          <transition enter-active-class="animated fadeInUp" leave-active-class="animated zoomOut">
            <template v-if="searchListBool">
              <template v-if="searchLists&&searchLists.length">
                <div class="search-result"  @mouseleave="searchLeave">
                  <div class="max-con">
                    <template v-for="(item,searchIndex) in searchLists">
                      <div class="search-result-list" :key="'searchLists'+searchIndex" @click="searchMap(searchIndex)">
                        <p class="oneRow">{{item.name}}</p>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </template>
          </transition>
        </div>
        <div class="industry-list-all" :class="[navBool&&industryList&&industryList.length?'active':'']">
          <template v-if="navBool&&industryList&&industryList.length">
            <div>
              <ul>
                <template v-for="(list,industryIndex) in industryList">
                  <li :key="'industryList'+industryIndex"
                      @click="industryClick(list.id,industryIndex)">
                    <i class="icon-img" :class="['icon-industry'+list.id]"></i>
                    {{list.name}}
                  </li>
                </template>
                <li @click="industryClick(0,-1)"><i class="icon-img icon-industry0"></i>全部行业</li>
              </ul>
            </div>
          </template>
        </div>
      </div>
      <transition enter-active-class="animated fadeInDown" leave-active-class="animated zoomOut">
        <div v-if="noDataBool" class="no-data-tips">暂无点位信息，请切换到其他{{tipsName}}看一看</div>
      </transition>
    </div>
    <div class="map-map-content" :style="'top:'+(navBool?topNavTrue:topNavFalse)+'px;'">
      <template v-if="tabLists&&tabLists.length">
        <div class="map-info-tab">
          <template v-for="(tab,tabIndex) in tabLists">
          <span :class="[tabActive==tabIndex?'active':'']" :key="'tabLists'+tabIndex" @click="panList(tab.getUrl,tabIndex)">
            {{tab.name}}
          </span>
          </template>
        </div>
      </template>
      <div id="mapDiv" class="animated zoomIn">
        <div id="mousePosition"></div>
        <div id="leftNavData" style="">
        </div>
      </div>
    </div>
    <div class="map-pan-list" :style="'top:'+(listsBool?(navBool?topNavTrue:topNavFalse)+'px;':'100%')">
      <div class="">
        <div class="map-pan-title">
          {{tabLists[tabActive].name}}全景<i class="icon-img icon-cuo" @click="closeLists"></i>
        </div>
        <div class="map-list max-con">
          <template v-if="lists&&lists.length">
            <ul class="">
              <template v-for="(item, index) in lists">
                <li :class="['list']"
                    :style="'animation-delay:0s;'"
                    :key="'map-list-content'+index">
                  <div class="posRe" @click="addressPunctuation(index)">
                    <div class="list-img" :style="'backgroundImage:url('+item.imgSrc+');'"><span class="icon-img img-list-see"></span></div>
                    <div class="list-content">
                      <h3 class="oneRow">{{item.name}}</h3>
                      <p class="oneRow">地址：{{item.address || '更新中'}}</p>
                      <p class="oneRow">电话：{{item.phone || '暂无'}}</p>
                     <!-- <div>
                        <span class="img-good"><i class="icon-img"></i>{{item.good}}</span>
                        <span class="img-share"><i class="icon-img"></i>{{item.share}}</span>
                      </div>-->
                    </div>
                  </div>
                  <a class="go-btn" :href="item.panoUrl">进入全景</a>
                </li>
              </template>
            </ul>
            <div v-show="loadingBool" id="related">
              <div class="loading"><i class="myicon icon-loading-1 load-icon"></i><span>加载中……</span></div>
            </div>
          </template>
          <template v-else>
            <div class="phone-no-data">
              <img :src="$noData" alt="">
              <p>暂无数据</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cityAddress from '@/components/Phone/cityAddress.vue'
import mapFun from '../../common/map.js'
export default {
  name: 'phoneMapIndex',
  inject: ['reload'],
  data () {
    return {
      parameter: {
        cityId: 0,
        typeId: 0,
        typeIndex: -1,
        cityIndex: -1,
        countyIndex: -1
      },
      tabLists: [
        {'name': '推荐', 'getUrl': 'PanoWebService.asmx/GetRecommendByCity'},
        {'name': '最新', 'getUrl': 'PanoWebService.asmx/GetLatestByCity'}
      ],
      params: {
        cityId: 0,
        typeId: 0,
        page: 1,
        limit: 10
      },
      addressShowBool: false,
      currentPage: 'map',
      addressAllData: [],
      addressCity: {cityId: 0, name: '四川省'},
      industryList: [],
      navBool: false,
      navName: '全部行业',
      flag: true,
      searchLists: [],
      searchListBool: true,
      searchKeyVal: '',
      tabActive: 0,
      lists: [],
      listsBool: false,
      loadingBool: false,
      scrollBool: true,
      total: 0,
      page: 1,
      topNavFalse: 104,
      topNavTrue: 104,
      url: '',
      noDataBool: false,
      tipsName: ''
    }
  },
  components: {
    cityAddress: cityAddress
  },
  created () {
    let that = this;
    if(that.$realmNameId==50){
      that.addressCity.name='重庆省'
    }
    that.parameter = that.publicJs.decodeFun(that.$route.query)
    that.params.cityId = that.parameter.cityId;
    that.params.typeId = that.parameter.typeId;
    that.industryData();
    that.addressAllDataFun()
  },
  mounted () {
    let that = this
    that.topNavFalse = that.$refs.mapTop.offsetHeight;
    if (that.scrollBool) {
      that.listScrollb()
    }
  },
  methods: {
    mapInit: function () {
    },
    searchEnter: function () {
      this.searchListBool = true
    },
    searchLeave: function () {
      this.searchListBool = false
    },
    compositionstart: function () {
      this.flag = false
    },
    compositionend: function () {
      this.flag = true
    },
    searchInput: function () {
      let that = this;
      if (that.searchKeyVal) {
        if (that.flag) {
          that.httpAjax.getAjax('PanoWebService.asmx/GetPanoByWhere_Map', {
            page: 1,
            cityId: 0,
            limit: 10000,
            typeId: 0,
            keyWords: that.searchKeyVal
          }).then(function (data) {
            if (data.code === 1) {
              that.searchLists = data.data
            }
          }, function (err) {
            console.log(err)
          })
        }
      } else {
        that.searchLists = []
      }
    },
    searchMap: function (i) {
      this.searchListBool = false
      mapFun.addressSite(this.searchLists[i])
    },
    industryData: function (index) {
      let that = this
      that.publicJs.navGetData(function (data) {
        if (data.code === 1) {
          that.industryList = data.data.concat(that.industryList)
        }
      })
    },
    industryClick: function (id, index) {
      let that = this
      that.params.typeId = id
      that.navBool = false
      if (index >= 0) {
        that.navName = that.industryList[index].name
      } else {
        that.navName = '全部行业'
      }
      that.tipsName = '行业'
      that.mapSearchInit()
    },
    industryFun: function () {
      let that = this
      that.searchLeave()
      that.navBool = !that.navBool
      that.$nextTick(function () {
        that.topNavTrue = that.$refs.mapTop.offsetHeight
      })
    },
    addressAllDataFun: function () {
      let that = this
      this.publicJs.addressGetData(function (res) {
        if (res.code === 1) {
          that.addressAllData = res.data || [];
          if (that.parameter.cityId >= 0) {
            let addressData =that.publicJs.onlyCityData(res.data,that.parameter.cityId);
            if (addressData.data) {
              addressData = addressData.data
            }
            that.addressCity = addressData || {cityId: 0, name: that.$realmNameId==50?'重庆':'四川'};
            // eslint-disable-next-line
            mapinit(that.addressCity.x, that.addressCity.y, that.addressCity.mapLevel,that.$realmNameId)
          } else {
            // eslint-disable-next-line
            if(that.$realmNameId==50){
              mapinit(106.54476999183, 29.568610399746, 6,that.$realmNameId)
            }else {
              mapinit(102.55879281894, 31.121115892911, 6,that.$realmNameId)
            }
          }
          that.publicJs.changeDocumentTitle(that.addressCity.name,that.addressCity.cityId);
          that.mapSearchInit()
        }
      })
    },
    mapSearchInit: function (addressPosition) {
      let that = this
      that.httpAjax.getAjax('PanoWebService.asmx/GetPanoByWhere_Map', {
        page: 1,
        cityId: that.params.cityId,
        limit: 10000,
        typeId: that.params.typeId,
        keyWords: that.searchListBool ? that.searchKeyVal || '' : ''
      }).then(function (data) {
        if (data.code === 1) {
          if (!data.total) {
          }
          let newData = JSON.parse(JSON.stringify(data.data))
          if (newData && newData.length === 0) {
            that.noDataBool = true
            setTimeout(function () {
              that.noDataBool = false
            }, 1500)
          }
          if (addressPosition) {
            // eslint-disable-next-line
            MAP.map.centerAndZoom(new T.LngLat(addressPosition.x, addressPosition.y), MAP.map.getZoom());
          }
          mapFun.ShowSearchPoint(newData, true)
        }
      }, function (err) {
        console.log(err)
      })
    },
    panList: function (url, index, bool) {
      let that = this
      that.listsBool = true
      that.lists = []
      if (that.url === url) {
        if (that.page > 1) {
          that.page = 1
        } else {
          that.httpData()
        }
      } else {
        that.url = url
      }
      that.tabActive = index
      that.tabClickBool = (bool || false)
    },
    httpData: function () {
      let that = this
      mapFun.mapFun(that.url, that.params, that.pageRefreshBool).then(function (res) {
        if (res.code === 1) {
          that.total = res.total
          let newData = JSON.parse(JSON.stringify(res.data))
          that.lists = that.lists.concat(newData)
          that.loadingBool = false
        }
      })
    },
    listScrollb: function () {
      let that = this
      that.scrollBool = false
      that.$nextTick(function () {
        $('.map-list').scroll(function (e) {
          if (that.publicJs.isScrollBottom(this)) {
            // 滚动到底端了 加载内容
            // 加载数据
            that.tabBool = true
            let p = that.page
            let l = that.params.limit
            if (p && l && (p * l < that.total)) {
              that.page++
              that.loadingBool = true
            }
          }
        })
      })
    },
    closeLists: function () {
      this.listsBool = false
      this.scrollBool = true
    },
    addressPunctuation: function (i) {
      let that = this
      this.listsBool = false
      this.scrollBool = true
      mapFun.addressSite(that.lists[i])
    },
    currentParamsVal: function (val) {
      let that = this
      if (val) {
        let allAddress = JSON.parse(JSON.stringify(that.addressAllData))
        let cityAddress = (val.cityIndex >= 0 ? allAddress[val.cityIndex] : {})
        if (val.countyIndex >= 0) {
          cityAddress = cityAddress.child[val.countyIndex]
        }
        that.addressCity = cityAddress
        that.params.cityId = val.cityId
        that.mapSearchInit(cityAddress)
      }
      that.addressShowBool = false
    },
    goAddressPage: function () {
      let that = this
      that.tipsName = '地方'
      that.addressShowBool = true
    },
    goBack: function () {
      let that = this
      let currentParams = that.publicJs.decodeFun(that.$route.query)
      this.$router.push({
        path: currentParams.cityId > 0 ? '/phoneCity' : '/phoneIndex',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            cityId: currentParams.cityId,
            typeId: 0,
            topIndex: 0,
            cityIndex: currentParams.cityIndex,
            countyIndex: currentParams.countyIndex
          })),
          '_': new Date().getTime()
        }
      })
    }
  },
  computed: {
  },
  watch: {
    url: {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          that.lists = []
          if (that.page === 1) {
            that.httpData()
          } else {
            that.page = 1
            that.params.page = 1
          }
        }
      },
      deep: true
    },
    page: {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          if (a === 1) {
            that.lists = []
          }
          that.params.page = a
          that.httpData()
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../../static/js/Map/css/map_css.css";
  @import "../../../static/js/Map/ol/ol.css";
  #app.screen3>.phone-map-page{
    overflow: hidden;
  }
  .map-top {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 6;
  }
  .top{
    color: #fff;
    background-color: #248DDF;
    padding: 9px 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .top>div{
    line-height: 26px;
    font-size: 15px;
    letter-spacing: 1px;
    position: relative;
  }
  .map-info{
    background-color: white;
  }
  .address-name{
    padding-right: 24px;
    float: left;
    position: relative;
  }
  .address-name .icon-down-white{
    position:absolute;
    right: 0;
    top: 50%;
    margin-top: -4px;
    width: 17px;
    height: 10px;
    opacity: 0.6;
    background-position: -310px -257px;
  }
  .top .icon-back{
    position: absolute;
    right: 0;
    left: initial;
    width: 22px;
    height: 19px;
    background-position: -64px -290px;
    top: 50%;
    margin-top: -9.5px;
  }
  .map-search-industry{
    padding: 14px 112px 14px 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  .map-search{
    border: 1px solid #D6D6D6;
    border-radius: 5px;
    /*padding: ;*/
    position: relative;
    padding: 0 60px 0 8px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  input::placeholder{
    color: #999999;
  }
  .map-search input{
    display: block;
    font-size: 12px;
    line-height: 28px;
    color: black;
    height: 28px;
    width: 100%;
  }
  .map-search:hover{
    border-color: #248ddf;
  }
  .map-search span{
    position: absolute;
    right: -1px;
    top: -1px;
    width: 50px;
    border-radius:5px;
    background-color: #248DDF;
    color: #fff;
    bottom: -1px;
    text-align: center;
    font-size: 13px;
    line-height: 30px;
    letter-spacing: 2px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .map-industry{
    position: absolute;
    right: 11px;
    top:50%;
    padding-right:20px;
    margin-top: -11px;
  }
  .map-industry .icon-down{
    position: absolute;
    right: 0;
    top:50%;
    margin-top: -4.5px;
  }
  .map-info-tab{
    padding: 7px 11px 12px;
    position: absolute;
    top: 59px;
    left: 10px;
    z-index: 5;
  }
  .map-info-tab>span{
    display:block;
    margin-right: 17px;
    background-color:#F6BC32;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1;
    padding: 8px;
    color: #FFFFFF;
    letter-spacing: 1px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 24px;
    position: relative;
    -webkit-box-shadow: 0 1px 5px rgba(0,0,0,0.4);
    -moz-box-shadow: 0 1px 5px rgba(0,0,0,0.4);
    box-shadow: 0 1px 5px rgba(0,0,0,0.4);
  }
  .map-info-tab>span::after{
    content: '';
    width: 0;
    height: 0;
    border-bottom: 10px solid #F6BC32;
    border-left: 14px solid transparent;
    position: absolute;
    transform: rotate(-32deg);
    left: 5px;
    bottom: -4px;
  }
  .map-info-tab>.active{
    background-color: #fe615a;
    color: white;
  }
  .map-info-tab>span.active::after{
    border-bottom-color: #fe615a;
  }
  .industry-list-all{
    height: 0;
    overflow: hidden;
  }
  .industry-list-all.active{
    height:auto;
    overflow: hidden;
    -webkit-transition: height 0.5s;
    -moz-transition: height 0.5s;
    -ms-transition: height 0.5s;
    -o-transition: height 0.5s;
    transition: height 0.5s;
  }
  .industry-list-all>div{
    background: #F2F2F2;
    padding:16px 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 9px 0 8px;
    /*-webkit-animation: fadeInDown 0.5s;
    -o-animation: fadeInDown 0.5s;
    animation: fadeInDown 0.5s;*/
  }
  .industry-list-all>div>ul{
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 14px;
    color: #666666;
    margin-top: -20px;
  }
  .industry-list-all li{
    position: relative;
    min-width: 25%;
    padding-left:24px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 20px;
  }
  .industry-list-all .mar-top{
  }
  .industry-list-all i{
    position: absolute;
    width: 19px;
    height: 19px;
    left: 0;
    top:50%;
    margin-top: -9.5px;
  }
  .industry-list-all .icon-industry8{
    background-position:-117px -316px;
  }
  .industry-list-all .icon-industry1{
    background-position: -149px -316px;
  }
  .industry-list-all .icon-industry3{
    background-position: -183px -316px;
  }
  .industry-list-all .icon-industry10{
    background-position: -212px -316px;
  }
  .industry-list-all .icon-industry7{
    background-position: -240px -315px;
  }
  .industry-list-all .icon-industry6{
    background-position: -271px -315px;
  }
  .industry-list-all .icon-industry0{
    background-position: -88px -316px;
  }
  .map-map-content{
    position: absolute;
    top: 150px;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    z-index: 3;
    -webkit-transition: top 0.5s;
    -moz-transition: top 0.5s;
    -ms-transition: top 0.5s;
    -o-transition: top 0.5s;
    transition: top 0.5s;
  }
  #mapDiv {
    width: 100%;
    height: 100%;
  }
  .search-result{
    height: auto;
    top:40px;
  }
  .search-result>div{
    max-height: 240px;
  }
  .icon-down{
    transform-origin: center;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  .map-industry.active .icon-down{
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
    transform: rotate(-180deg);
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
  }
  .map-pan-list{
    position: absolute;
    top:110%;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.6);
    z-index: 6;
    padding-top:42px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: top 0.5s;
    -moz-transition: top 0.5s;
    -ms-transition: top 0.5s;
    -o-transition: top 0.5s;
    transition: top 0.5s;
  }
 /* .map-pan-list.active{
    -webkit-animation: fadeInUp 0.5s;
    -o-animation: fadeInUp 0.5s;
    animation: fadeInUp 0.5s;
  }
  .map-pan-list.no-active{
    -webkit-animation: fadeOub 0.5s;
    -o-animation: fadeOub 0.5s;
    animation: fadeOub 0.5s;
  }*/
  .map-pan-list>div{
    height: 100%;
    background: #F2F2F2;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.29);
    border-radius: 5px 5px 0px 0px;
    padding:40px 0 0 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  .map-pan-title{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    text-align: center;
    line-height: 40px;
  }
  .icon-cuo{
    position: absolute;
    right: 11px;
    top:50%;
    margin-top: -9px;
  }
  .map-pan-list>div .map-list{
    height: 100%;
    padding-right: 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .go-btn{
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 11px;
    color: #248DDF;
    border: 1px solid #248DDF;
    border-radius: 2px;
    padding: 3px 6px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 4;
  }
  /*.map-list .list::after{
    display: none;
  }*/
</style>



// WEBPACK FOOTER //
// src/Phone/map/index.vue